import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

export interface CreateRoomPartyInput {
    data: {
        group_booking_id: number
        hotel_resource_id: number | null
        disabled: boolean
        start_date: string
        end_date: string
        wheelchair_access: boolean
        has_infants: boolean
        notes: string
        members_different_dates: boolean
    }
}

interface CreateRoomPartyData {
    createRoomParty: RoomParty
}

export const CREATE_ROOM_PARTY_MUTATION = gql`
    mutation createRoomParty($data: CreateRoomPartyInput!) {
        createRoomParty(data: $data) {
            ${gqlRoomParty}
        }
    }
`;

export const createRoomParty = () => useMutation<CreateRoomPartyData, CreateRoomPartyInput>(
    CREATE_ROOM_PARTY_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default createRoomParty;